import { InjectionToken } from '@angular/core';

export interface EntraExternalIdClientConfig {
  readonly provider: 'Microsoft Entra External ID';
  readonly enabled: boolean;
  readonly tenantId: string;
  readonly tenantName: string;
  readonly clientId: string;
  readonly authority: string;
  readonly knownAuthorities: readonly string[];
  readonly redirectUri: string;
  readonly postLogoutRedirectUri: string;
  readonly apiBaseUrl: string;
  readonly apiScopes: readonly string[];
  readonly signUpSignInPolicyId: string;
  readonly enableLocalAccounts: boolean;
  readonly brandedDomain: string;
  readonly portalAdminGroupId: string;
}

export const ENTRA_AUTH_CONFIG = new InjectionToken<EntraExternalIdClientConfig>(
  'ENTRA_AUTH_CONFIG'
);

export function hasPlaceholderEntraConfig(config: EntraExternalIdClientConfig): boolean {
  return (
    config.clientId.includes('<')
    || config.tenantId.includes('<')
    || config.authority.includes('<')
    || config.apiScopes.some((scope) => scope.includes('<'))
  );
}

